<div
	class="h-full mt-24px pb-[100px] px-12px custom-filter"
	[formGroup]="filterForm"
>
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" class="flex text-link" (click)="resetFilter()">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<app-custom-datepicker
			[defaultValue]="getController('startDate').value"
			label="GENERAL_LABELS.START_DATE"
			(dateValue)="getController('startDate').setValue($event)"
		></app-custom-datepicker>
		<app-custom-datepicker
			[defaultValue]="getController('endDate').value"
			label="GENERAL_LABELS.END_DATE"
			(dateValue)="getController('endDate').setValue($event)"
		></app-custom-datepicker>
		<mat-error
			*ngIf="
				getController('endDate').value < getController('startDate').value &&
				getController('endDate').value
			"
		>
			<div class="whitespace-nowrap">
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>

	<div>
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'STORE.ORDER_LIST.CITY' | translate }}
		</p>
		<mat-form-field
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			class="w-full"
			appearance="outline"
			(click)="showCityList = !showCityList; getCities()"
		>
			<mat-label>{{ 'GENERAL_LABELS.SEARCH_CITY' | translate }}</mat-label>
			<input type="text" matInput [formControl]="keywordCity" />
			<img
				*ngIf="!keywordCity?.value"
				class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
				src="assets/images/arrow.png"
			/>

			<img
				(click)="
					keywordCity.setValue('');
					keywordArea.setValue('');
					filterForm.controls['cityId'].setValue(null);
					filterForm.controls['areaId'].setValue(null);
					Areas = []
				"
				*ngIf="keywordCity?.value"
				src="./assets/images/close-square.svg"
				class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
			/>
		</mat-form-field>
		<ul class="autoCompleteList" *ngIf="showCityList">
			<li
				*ngFor="let name of cities"
				(click)="
					filterForm.controls['cityId'].setValue(name.id);
					this.translate.currentLang == 'en'
						? keywordCity.setValue(name?.name?.en)
						: keywordCity.setValue(name?.name?.ar);
					this.isAreasLoaded = false;
					getAreas();
					showCityList = !showCityList
				"
			>
				{{
					this.translate.currentLang == 'en' ? name?.name?.en : name?.name?.ar
				}}
			</li>
			<li *ngIf="!cities?.length && showCityList" class="text-center">
				{{ 'GENERAL.NO_DATA_FOUND' | translate }}
			</li>
		</ul>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
	<div>
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'STORE.ORDER_LIST.AREA' | translate }}
		</p>
		<mat-form-field
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			class="w-full"
			appearance="outline"
			(click)="showAreaList = !showAreaList"
		>
			<mat-label>{{ 'GENERAL_LABELS.SEARCH_AREA' | translate }}</mat-label>
			<input type="text" matInput [formControl]="keywordArea" />
			<img
				*ngIf="!keywordArea?.value"
				class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
				src="assets/images/arrow.png"
			/>

			<img
				(click)="keywordArea.setValue('')"
				*ngIf="keywordArea?.value"
				src="./assets/images/close-square.svg"
				class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
			/>
		</mat-form-field>
		<ul class="autoCompleteList" *ngIf="showAreaList">
			<li
				*ngFor="let name of Areas"
				(click)="
					filterForm.controls['areaId'].setValue(name.id);
					this.translate.currentLang == 'en'
						? keywordArea.setValue(name?.name?.en)
						: keywordArea.setValue(name?.name?.ar);
					getAreas();
					showAreaList = !showAreaList
				"
			>
				{{
					this.translate.currentLang == 'en' ? name?.name?.en : name?.name?.ar
				}}
			</li>
			<li *ngIf="!Areas?.length && showAreaList" class="text-center">
				{{ 'GENERAL.NO_DATA_FOUND' | translate }}
			</li>
		</ul>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-[16px]"></div>

	<div>
		<p
			class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
		>
			{{ 'BOOKING.BOOKING_DETAILS.PAYMENT_METHOD' | translate }}
		</p>

		<ng-container *ngFor="let paymentArrayy of paymentArray; let i = index">
			<div
				*ngIf="i !== 2"
				class="flex justify-between py-[8px] pl-[16px] pr-[24px] border-[1px] border-solid border-[#D9DBE9] rounded-12px mb-[6px]"
			>
				<div>
					<mat-checkbox
						(change)="paymentChanged($event, 'paymentMethod')"
						[value]="paymentArrayy?.value"
						class="ltr:mr-2 rtl:ml-2"
						[checked]="
							getController('paymentMethod')?.value?.includes(
								paymentArrayy?.value
							)
						"
					>
					</mat-checkbox>
					{{ 'STATUS.' + paymentArrayy['name'].toUpperCase() | translate }}
				</div>

				<img
					*ngIf="i != 4"
					src="assets/images/pay{{ i }}.svg"
					alt=""
					srcset=""
				/>
				<img
					*ngIf="i == 4"
					src="assets/images/money-recive.svg"
					alt=""
					srcset=""
				/>
			</div>
		</ng-container>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-[16px]"></div>

	<div>
		<p
			class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
		>
			{{ 'BOOKING.BOOKING_DETAILS.PAYMENT_STATUS' | translate }}
		</p>

		<div
			*ngFor="
				let PaymentStatuss of PaymentStatus;
				let indx = index;
				let last = last
			"
			class="{{ last ? 'pb-24px' : '' }}"
		>
			<ng-container *ngIf="indx != 2 && indx != 3">
				<mat-checkbox
					(change)="paymentChanged($event, 'paymentStatus')"
					[value]="PaymentStatuss?.value"
					class="ltr:mr-2 rtl:ml-2 mb-[19px]"
					[checked]="
						getController('paymentStatus')?.value?.includes(
							PaymentStatuss?.value
						)
					"
				>
				</mat-checkbox>
				{{ 'STATUS.' + PaymentStatuss['name'].toUpperCase() | translate }}
			</ng-container>
		</div>
	</div>

	<button
		[disabled]="
			filterCount == 0 ||
			(getController('endDate').value < getController('startDate').value &&
				getController('endDate').value)
		"
		class="bg-gradient text-white w-[89%] p-0 absolute bottom-2"
		mat-button
		(click)="submit()"
	>
		{{ 'ACTIONS.APPLY_FILTER' | translate }}
	</button>
</div>
